import React from "react";

export const Settings: React.FC = () => {
  const settingsData = [
    { name: "Connect on Load", description: "Automatically connects to SAMMI Core when opening the app. Disable to connect manually.", platform: "All" },
    { name: "Keep Awake", description: "Prevents the device from sleeping while Deck Hopper is running, keeping the screen on.", platform: "Mobile Only" },
    { name: "Enable Fullscreen", description: "Enables full‑screen mode for Deck Hopper. When 'Connect on Load' is enabled, Deck Hopper enters full‑screen mode after interaction.", platform: "Desktop Only" },
    { name: "Always On Top", description: "Ensures Deck Hopper remains on top of other windows.", platform: "Desktop Only" },
    { name: "Persistent Navigation Bar", description: "Keeps the navigation bar visible while inside a deck.", platform: "All" },
    { name: "Disable Context Menu", description: "Disables the right‑click context menu in the app. Useful for touch‑screen devices on desktop.", platform: "Desktop Only" },
    { name: "Hide Hopper Button", description: "Hides the floating Hopper button while inside a deck.", platform: "Android Only" },
    { name: "Screen Orientation", description: "Force and lock Deck Hopper's orientation. This overrides system rotation until your change it back to Auto. Experimental Feature.", platform: "Android Only" },
    { name: "Disable Haptic Feedback", description: "Disables vibration feedback when interacting with the app.", platform: "Mobile Only" },
    { name: "Show Disabled Decks", description: "Display decks in the deck list currently disabled in SAMMI.", platform: "All" },
    { name: "Show Hidden Decks", description: "Display decks in the deck list you set to hidden in Deck Hopper.", platform: "All" },
    { name: "Strict Image Checking", description: "Enable this if you often change button/deck images using the same file name. Affects performance.", platform: "All" },
    { name: "Twitch Embed Login", description: "Log into Twitch to interact with Twitch Embed buttons, allowing you to send chat messages while logged in.", platform: "Android Only" },
    { name: "Opt out of error reporting", description: "Prevents sending anonymous error reports to the developer.", platform: "All" },
    { name: "Enable Console Logs", description: "Enable additional logging before submitting a bug report. Disable once you're done.", platform: "All" },
  ];

  return (
    <div className="flex flex-col gap-y-4 mb-4 mt-4 px-4 max-w-screen-sm mx-auto">
      <p>
        Navigate to <b>Menu → Settings</b> to configure:
      </p>

      {/* mobile list */}
      <div className="block md:hidden space-y-4">
        {settingsData.map(({ name, description, platform }) => (
          <div key={name} className="border border-gray-700 rounded-lg p-4">
            <div className="font-semibold">{name}</div>
            <div className="text-sm mt-1">{description}</div>
            <div className="mt-2 text-xs text-gray-300 italic">Platform: {platform}</div>
          </div>
        ))}
      </div>

      {/* desktop/tablet table */}
      <div className="hidden md:block border border-gray-700 rounded-xl shadow-lg overflow-x-auto">
        <table className="table-fixed w-full text-left">
          <colgroup>
            <col className="w-1/4" />
            <col className="w-1/2" />
            <col className="w-1/4" />
          </colgroup>
          <thead>
            <tr className="border-b border-gray-700">
              <th className="px-4 py-3">Setting</th>
              <th className="px-4 py-3">Description</th>
              <th className="px-4 py-3">Platform</th>
            </tr>
          </thead>
          <tbody>
            {settingsData.map(({ name, description, platform }) => (
              <tr key={name} className="border-b border-gray-700">
                <td className="px-4 py-3 break-words">{name}</td>
                <td className="px-4 py-3 break-words">{description}</td>
                <td className="px-4 py-3 break-words">{platform}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
